import React, { useEffect, useState } from "react";

const reloadPage = () => window.location.reload();

// No automatic reload loop, storage deletion, sign-out, or financial action.
export function PageLoadRecovery({ title = "Let's reopen your club", message = "The page couldn't finish loading. Please try again.", onRetry = reloadPage, onSignIn, onReload, testId = "vendor-page-recovery" }) {
    return (
        <main className="grid min-h-[100dvh] place-items-center bg-[#fffae5] px-6 text-slate-900" data-testid={testId}>
            <section className="w-full max-w-sm rounded-3xl bg-white p-6 text-center shadow-sm" role="alert">
                <h1 className="text-xl font-bold">{title}</h1>
                <p className="my-4 text-sm text-slate-600">{message}</p>
                <button type="button" className="rounded-xl bg-emerald-800 px-6 py-3 font-bold text-white" onClick={onRetry}>Retry</button>
                {onSignIn && <button type="button" className="mt-4 block w-full text-sm font-semibold text-slate-600" onClick={onSignIn}>Back to sign in</button>}
                {onReload && <button type="button" className="mt-4 block w-full text-sm font-semibold text-slate-600" onClick={onReload}>Reload page</button>}
            </section>
        </main>
    );
}

export function PageLoading({ onRetry = reloadPage, slowAfterMs = 10000, quiet = false, background = "#fffae5", testId }) {
    const [slow, setSlow] = useState(false);
    useEffect(() => {
        const timer = window.setTimeout(() => setSlow(true), slowAfterMs);
        return () => window.clearTimeout(timer);
    }, [slowAfterMs]);
    if (slow) return <PageLoadRecovery title="Loading is taking longer than expected" message="Check your connection, then retry. Your sign-in is kept." onRetry={onRetry} testId="page-loading-recovery" />;
    return (
        <main className="grid min-h-[100dvh] place-items-center px-6 text-slate-900" style={{ backgroundColor: background }} data-testid={testId} data-startup-pending="true" aria-busy="true" aria-label="Loading page">
            {!quiet && <p className="text-sm font-semibold" role="status">Loading your club…</p>}
        </main>
    );
}

// Covers provider/layout failures as well as lazy-route render exceptions.
// The bounded user-controlled retry preserves all browser credentials/data.
export default class StartupPageRecovery extends React.Component {
    state = { failed: false, attempt: 0 };
    static getDerivedStateFromError() { return { failed: true }; }
    componentDidCatch() { console.error("[App] Page render failed; recovery screen displayed."); }
    render() {
        if (!this.state.failed) return <React.Fragment key={this.state.attempt}>{this.props.children}</React.Fragment>;
        return <PageLoadRecovery onRetry={() => this.setState(({ attempt }) => ({ failed: false, attempt: attempt + 1 }))} onReload={reloadPage} />;
    }
}
